import React from "react";
import { Instruction, Instructions } from "../shared_ui.jsx";

export const HowToFax = () => {
  return (
    <section>
      <div className="my-4">
        <h2 className="text-center text-sm-start">How To Fax</h2>
      </div>

      <div>
        <_Instructions />
      </div>
    </section>
  );
};

export const _Instructions = () => (
  <Instructions>
    <Instruction
      number={"1"}
      instruction={"Place your documents into the printer's input tray."}
    />
    <Instruction
      number={"2"}
      instruction={
        'Select "Fax", enter your email address and PIN, and follow the prompts.'
      }
    />
    <Instruction
      number={"3"}
      instruction={"Accept the charges on the screen to begin faxing."}
    />
  </Instructions>
);
